import styled from "styled-components";

import { StatusLabelStyledProps as Props } from "./StatusLabel.types";
import CONSTANTS from "config/constants";

const { mobile, tablet } = CONSTANTS.BREAKPOINTS;

const StatusLabelStyled = styled.div<Props>`
  justify-content: center;
  align-items: center;
  display: flex;

  .StatusLabel {
    &__circle {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      background-color: ${props => props.backgroundColor};
    }

    &__text {
      font-size: 1.4rem;
      line-height: 1.8rem;
      padding-left: 0.8rem;
      padding-right: 1.6rem;
      color: var(--palette-white);

      @media (max-width: ${tablet}px) {
        text-overflow: ellipsis;
        width: auto;
        overflow: hidden;
        white-space: nowrap;
      }

      @media (max-width: ${mobile - 1}px) {
        font-size: 1.2rem;
        text-overflow: unset;
        overflow: hidden;
        width: auto;
      }
    }
  }
`;

export default StatusLabelStyled;
